// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".ProfileMenu .ProfileDropdownButton{border-radius:24px;border:1px solid #e0e7f2;background-color:#f1f5fc;padding:5px !important}.ProfileMenu .ProfileImage{width:24px;height:24px;border-radius:100%;background-color:#fff;-o-object-fit:cover;object-fit:cover}\n", ""]);
// Exports
module.exports = exports;
